document.addEventListener('DOMContentLoaded', () => {
    const viewers = document.querySelectorAll('.pdf-hybrid-viewer');

    viewers.forEach(async (block) => {
        // --- SELECTORS ---
        const url = block.dataset.pdfUrl;
        const interfaceWrapper = block.querySelector('.viewer-interface-wrapper');
        const loadingOverlay = block.querySelector('.pdf-loading-overlay');
        
        // Buttons
        const prevBtn = block.querySelector('.prev-btn');
        const nextBtn = block.querySelector('.next-btn');
        const sidePrev = block.querySelector('.side-prev');
        const sideNext = block.querySelector('.side-next');
        const zoomInBtn = block.querySelector('.zoom-in-btn');
        const zoomOutBtn = block.querySelector('.zoom-out-btn');
        const fullscreenBtn = block.querySelector('.fullscreen-btn');
        const pageInput = block.querySelector('.page-current');
        const totalSpan = block.querySelector('.page-total');

        if (!url) return;

        // --- STATE ---
        let pdfDoc = null;
        let activeEngine = null; 
        let swiperInstance = null;
        
        // Book State
        let currentSheetIndex = 0; 
        let highestZ = 100;
        let scale = 0.85; 
        let panX = 0, panY = 0;
        let isDragging = false;
        
        // Track the actual PDF page number to sync between modes
        let globalCurrentPageNum = 1;

        // --- INIT ---
        if (typeof pdfjsLib === 'undefined') return;
        if (typeof flipbookSettings !== 'undefined' && flipbookSettings.workerUrl) {
            pdfjsLib.GlobalWorkerOptions.workerSrc = flipbookSettings.workerUrl;
        } else {
            pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';
        }

        try {
            const loadingTask = pdfjsLib.getDocument(url);
            pdfDoc = await loadingTask.promise;
            if(totalSpan) totalSpan.textContent = pdfDoc.numPages;

            initBasedOnResolution();
            
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(initBasedOnResolution, 200);
            });
            
            bindToolbarEvents();

        } catch (err) {
            console.error(err);
            if(loadingOverlay) loadingOverlay.innerHTML = "<p>Error loading PDF</p>";
        }

        function initBasedOnResolution() {
            const isMobile = window.innerWidth < 768;
            
            // If mode hasn't changed, do nothing
            if (isMobile && activeEngine === 'swiper') return;
            if (!isMobile && activeEngine === 'custom') return;

            cleanup();

            if (isMobile) initMobile();
            else initCustomBook();
            
            if(loadingOverlay) loadingOverlay.classList.add('hidden');
        }

        function cleanup() {
            if (swiperInstance) { 
                // Save position before destroying
                if(swiperInstance.activeIndex !== undefined) {
                    globalCurrentPageNum = swiperInstance.activeIndex + 1;
                }
                swiperInstance.destroy(true, true); 
                swiperInstance = null; 
            }
            
            if (activeEngine === 'custom') {
                // Calculate approximate page from sheet index
                globalCurrentPageNum = (currentSheetIndex * 2) + 1;
            }

            // Clear containers manually
            const mobileWrapper = block.querySelector('.swiper-wrapper');
            if(mobileWrapper) mobileWrapper.innerHTML = '';
            
            const bookContainer = block.querySelector('#custom-book');
            if(bookContainer) bookContainer.innerHTML = '';

            activeEngine = null;
        }

        // ==========================================
        //  MODE A: MOBILE (SWIPER)
        // ==========================================
        function initMobile() {
            activeEngine = 'swiper';
            const wrapper = block.querySelector('.swiper-wrapper');
            
            // Build Slides
            for (let i = 1; i <= pdfDoc.numPages; i++) {
                const slide = document.createElement('div');
                slide.className = 'swiper-slide';
                slide.innerHTML = `<div class="swiper-zoom-container">
                    <div class="pdf-page-placeholder" data-page="${i}" style="width:100%; height:100%; min-height:300px;"></div>
                </div>`;
                wrapper.appendChild(slide);
            }

            if (typeof Swiper === 'undefined') return;

            swiperInstance = new Swiper(block.querySelector('.swiper'), {
                slidesPerView: 1, spaceBetween: 10, zoom: true,
                // Sync: Start at the page we were on
                initialSlide: globalCurrentPageNum > 0 ? globalCurrentPageNum - 1 : 0,
                on: {
                    slideChange: () => { 
                        if (!swiperInstance) return;
                        const p = swiperInstance.activeIndex + 1;
                        globalCurrentPageNum = p;
                        updateUI(p); 
                        renderPage(p); 
                    },
                    init: () => { 
                        updateUI(globalCurrentPageNum); 
                        renderPage(globalCurrentPageNum); 
                    }
                }
            });
        }

        // ==========================================
        //  MODE B: DESKTOP (CUSTOM CSS BOOK)
        // ==========================================
        function initCustomBook() {
            activeEngine = 'custom';
            const book = block.querySelector('#custom-book');
            
            // Accurate Sheet Count (No +1)
            const totalSheets = Math.ceil(pdfDoc.numPages / 2);

            for (let i = 0; i < totalSheets; i++) {
                const pageDiv = document.createElement('div');
                pageDiv.className = 'page';
                pageDiv.id = `sheet-${i}`;
                pageDiv.style.zIndex = totalSheets - i; 

                // Front
                const front = document.createElement('div');
                front.className = 'front';
                const frontPdfNum = (i * 2) + 1;
                if (frontPdfNum <= pdfDoc.numPages) {
                    front.innerHTML = `<div class="pdf-page-placeholder" data-page="${frontPdfNum}"></div>`;
                }

                // Back
                const back = document.createElement('div');
                back.className = 'back';
                const backPdfNum = (i * 2) + 2;
                if (backPdfNum <= pdfDoc.numPages) {
                    back.innerHTML = `<div class="pdf-page-placeholder" data-page="${backPdfNum}"></div>`;
                }

                pageDiv.appendChild(front);
                pageDiv.appendChild(back);

                pageDiv.onclick = (e) => {
                    if (isDragging) return;
                    if (pageDiv.classList.contains('flipped')) goCustomPrev();
                    else goCustomNext();
                };

                book.appendChild(pageDiv);
            }

            // Reset State
            scale = 0.85; panX = 0; panY = 0;
            highestZ = 100; 
            
            // Sync Position
            const targetSheet = Math.floor((globalCurrentPageNum - 1) / 2);
            currentSheetIndex = 0;

            // Fast-forward flips
            const sheets = block.querySelectorAll('.page');
            for(let i = 0; i < targetSheet; i++) {
                if(sheets[i]) {
                    sheets[i].classList.add('flipped');
                    sheets[i].style.zIndex = highestZ++;
                }
            }
            currentSheetIndex = targetSheet;

            updateCustomTransform();
            setupCustomDrag();
            
            // Render visible area
            renderDesktopVisible();
        }

        function goCustomNext() {
            const sheets = block.querySelectorAll('.page');
            if (currentSheetIndex < sheets.length) {
                const sheet = sheets[currentSheetIndex];
                sheet.style.zIndex = highestZ++;
                sheet.classList.add('flipped');
                currentSheetIndex++;
                renderDesktopVisible();
            }
        }

        function goCustomPrev() {
            // FIX: Re-query sheets so variable exists
            const sheets = block.querySelectorAll('.page');
            
            if (currentSheetIndex > 0) {
                currentSheetIndex--;
                const sheet = sheets[currentSheetIndex]; 
                if(sheet) {
                    sheet.style.zIndex = highestZ++;
                    sheet.classList.remove('flipped');
                }
                renderDesktopVisible();
            }
        }

        function renderDesktopVisible() {
            const visiblePage = (currentSheetIndex * 2) + 1; 
            globalCurrentPageNum = visiblePage;
            updateUI(visiblePage);

            const p1 = (currentSheetIndex * 2) + 1;
            const p2 = (currentSheetIndex * 2) + 2;
            const p3 = (currentSheetIndex * 2) + 3;
            const p4 = (currentSheetIndex * 2) + 4;
            
            renderPage(p1); renderPage(p2); renderPage(p3); renderPage(p4);
            
            if(currentSheetIndex > 0) {
                renderPage((currentSheetIndex * 2));
                renderPage((currentSheetIndex * 2) - 1);
            }
        }

        // --- SHARED RENDERER ---
        async function renderPage(num) {
            if(num < 1 || num > pdfDoc.numPages) return;
            const placeholder = block.querySelector(`.pdf-page-placeholder[data-page="${num}"]`);
            if (!placeholder || placeholder.hasAttribute('data-rendered')) return;

            try {
                placeholder.setAttribute('data-rendered', 'true');
                const page = await pdfDoc.getPage(num);
                const viewport = page.getViewport({ scale: 2 });
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                canvas.className = 'pdf-page-canvas';
                
                placeholder.innerHTML = '';
                placeholder.appendChild(canvas);
                await page.render({ canvasContext: ctx, viewport }).promise;
            } catch (e) {}
        }

        // --- CUSTOM ZOOM/DRAG ---
        function updateCustomTransform() {
            const stage = block.querySelector('.zoom-stage');
            if(stage) stage.style.transform = `translate(${panX}px, ${panY}px) scale(${scale})`;
        }

        function setupCustomDrag() {
            const viewport = block.querySelector('.zoom-viewport');
            // Remove old listeners
            viewport.onmousedown = null;

            viewport.onmousedown = (e) => {
                if(e.target.closest('.tool-btn') || e.target.closest('input')) return;
                
                isDragging = false; 
                const startMouseX = e.clientX;
                const startMouseY = e.clientY;
                const startPanX = panX;
                const startPanY = panY;
                viewport.classList.add('grabbing');

                function onMove(moveE) {
                    const dx = moveE.clientX - startMouseX;
                    const dy = moveE.clientY - startMouseY;
                    if(Math.abs(dx) > 5 || Math.abs(dy) > 5) isDragging = true;
                    panX = startPanX + dx;
                    panY = startPanY + dy;
                    updateCustomTransform();
                }

                function onUp() {
                    viewport.classList.remove('grabbing');
                    setTimeout(() => { isDragging = false; }, 50);
                    window.removeEventListener('mousemove', onMove);
                    window.removeEventListener('mouseup', onUp);
                }
                window.addEventListener('mousemove', onMove);
                window.addEventListener('mouseup', onUp);
            };
        }

        // --- BINDING ---
        function updateUI(pageNum) { if (pageInput) pageInput.value = pageNum; }

        function bindToolbarEvents() {
            // FIX: Added safety check for swiperInstance
            const doNext = () => {
                if (activeEngine === 'swiper') {
                    if (swiperInstance) swiperInstance.slideNext();
                } else {
                    goCustomNext();
                }
            };
            
            const doPrev = () => {
                if (activeEngine === 'swiper') {
                    if (swiperInstance) swiperInstance.slidePrev();
                } else {
                    goCustomPrev();
                }
            };

            if(prevBtn) prevBtn.onclick = doPrev;
            if(nextBtn) nextBtn.onclick = doNext;
            if(sidePrev) sidePrev.onclick = doPrev;
            if(sideNext) sideNext.onclick = doNext;

            zoomInBtn.onclick = () => {
                if (activeEngine === 'swiper') {
                    if (swiperInstance) swiperInstance.zoom.in();
                } else { 
                    scale += 0.2; updateCustomTransform(); 
                }
            };
            zoomOutBtn.onclick = () => {
                if (activeEngine === 'swiper') {
                    if (swiperInstance) swiperInstance.zoom.out();
                } else { 
                    if(scale > 0.4) scale -= 0.2; updateCustomTransform(); 
                }
            };

            // FIX: Ensure interfaceWrapper is accessible
            if(fullscreenBtn && interfaceWrapper) {
                fullscreenBtn.onclick = () => {
                    const isFs = interfaceWrapper.classList.contains('is-fullscreen');
                    if (!isFs) {
                        interfaceWrapper.classList.add('is-fullscreen');
                        if(activeEngine === 'custom') { panX = 0; panY = 0; updateCustomTransform(); }
                    } else {
                        interfaceWrapper.classList.remove('is-fullscreen');
                        if(activeEngine === 'custom') { panX = 0; panY = 0; updateCustomTransform(); }
                    }
                };
            }
        }
    });
});